import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonColors, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import FormBuilder from '@s-ui/react-form-builder'
import FormConditionsAndPrivacyCheckbox from '@adv-mt/mt-form-conditions-and-privacy-checkbox'

import useFormC2bUserData from './useFormC2bUserData.js'

const BASE_CLASS_NAME = 'mt-FormC2bUserData'
const NO_OP = () => {}

const FormC2bUserData = ({
  onAutocompleteFields = NO_OP,
  onClickSubmit = NO_OP,
  onFieldChange = NO_OP,
  onSubmitError = NO_OP
}) => {
  const {i18n} = useContext(Context)
  const {
    // config
    formConfiguration,
    initialValues,
    SUIComponentsConfig,
    // state
    isLoading,
    isPrivacyChecked,
    isPrivacyError,
    isUserLogged,
    validatedErrors,
    // handlers
    handleChangePrivacyCheckbox,
    handleOnBlur,
    handleOnChange,
    handleOnSubmit,
    setValidatedErrors
  } = useFormC2bUserData({
    onAutocompleteFields,
    onClickSubmit,
    onFieldChange,
    onSubmitError
  })

  return (
    <div>
      <div className={`${BASE_CLASS_NAME}Container`}>
        <FormBuilder
          allowAutoFillOnInitLoad
          errors={validatedErrors}
          initFields={initialValues}
          json={formConfiguration}
          onBlur={handleOnBlur}
          onChange={handleOnChange}
          setErrors={setValidatedErrors}
        >
          {SUIComponentsConfig}
        </FormBuilder>
      </div>
      {!isUserLogged && (
        <div className={`${BASE_CLASS_NAME}PrivacyCheckbox`}>
          <FormConditionsAndPrivacyCheckbox
            checked={isPrivacyChecked}
            isError={isPrivacyError}
            onChange={handleChangePrivacyCheckbox}
          />
        </div>
      )}
      <div className={`${BASE_CLASS_NAME}Button`}>
        <AtomButton
          color={atomButtonColors.ACCENT}
          isLoading={isLoading}
          fullWidth
          onClick={handleOnSubmit}
          shape={atomButtonShapes.CIRCULAR}
          size={atomButtonSizes.LARGE}
        >
          {i18n.t('INSTANT_OFFER.STANDALONE.USER_DATA.GET_APPRAISAL_BUTTON')}
        </AtomButton>
      </div>
    </div>
  )
}

FormC2bUserData.displayName = 'FormC2bUserData'

FormC2bUserData.propTypes = {
  onAutocompleteFields: PropTypes.func,
  onClickSubmit: PropTypes.func,
  onFieldChange: PropTypes.func,
  onSubmitError: PropTypes.func
}

export default FormC2bUserData
